<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Notas de Prensa</template>
                    <template slot="en">Press Release</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <router-view></router-view>

    <section class="light-content">
        <div class="container">
            <div class="title-finder d-flex justify-content-between align-items-center">
                <p class="title-content title-content-tertiary">
                    <text-lang :lang="lang">
                        <template slot="es">Todas</template>
                        <template slot="en">All Posts</template>
                    </text-lang>
                </p>
                <finder @keyup="searching" style="margin-bottom: 20px" />
            </div>
            <box-container size="3">
                <box v-for="(post,index) in postsFiltered" :key="index" 
                    height="auto" borderColor="#f2f2f2" style="margin: 10px">
                    <post 
                        type="thumbnail" 
                        :post="post" 
                        :postContentTruncate="postContentTruncate"
                        :isLinkable="true" />
                </box>
            </box-container>
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import BoxContainer from '@/components/BoxContainer.vue'
import Box from '@/components/Box.vue'
import Finder from '@/components/Finder.vue'
import Post from '@/components/Post.vue'
import TextLang from '@/components/TextLang.vue'
import posts from '@/posts.js'

export default {
    name: 'PressRelease',
    props: ['lang'],
    components: {
        Parallax,
        BoxContainer,
        Box,
        Finder,
        Post,
        TextLang
    },
    data() {
        return {
            postContentTruncate: 84,
            posts: posts,
            postsFiltered: posts
        }
    },
    methods: {
        searching(input) {
            var val = input.target.value
            if(val)
                this.postsFiltered = {...this.posts.filter(post => { return post.title.toLowerCase().includes(val) })}
            else
                this.postsFiltered = this.posts
        }
        
    }
}
</script>
